<template>
  <landing-page>
    <template #heading>
      Thousands of royalty free tracks for creators
    </template>
    <template #tagline>
      Thousands of hand-picked, royalty free tracks for your videos.
    </template>

    <template #section-1-heading>
      Thousands of hand-picked royalty free tracks
    </template>
    <template #section-1-text>
      Don't settle for stock. Each of our 3 plans give you unlimited access to download and use quality royalty free music from real artists, and keeps the process simple - all at an unbeatable price.
    </template>
  </landing-page>
</template>

<script>
import LandingPage from '@/components/LandingPage.vue'

export default {
  name: 'LandingPageBestMusic',

  components: {
    LandingPage
  }
}
</script>
